import { useInterval } from '@chakra-ui/react';
import { useMemo, useRef, useState } from 'react';

interface TimerProps {
  onExpire(): void;
  expiresInMs: number;
}

const ONE_DAY = 60 * 60 * 24;
const ONE_HOUR = 60 * 60;
const ONE_MINUTE = 60;

/**
 * @param {{milliseconds: number }} props - retorna um timestamp somando os ms para o futuro
 */
export function msToTimestamp(milliseconds: number) {
  return new Date().getTime() + milliseconds;
}

/**
 * @param {{expiresInMs: number }} props - type number porem, essa prop deve ser utilizada com a funcao msToTimestamp
 * esta funcao retorna um timestamp do futuro, desta forma tendo o valor correto, mesmo que tenha re-render
 */
export function Timer(props: TimerProps) {
  const [currentTime, setCurrentTime] = useState(new Date().getTime());

  const { onExpire, expiresInMs } = props;
  const expiresInRef = useRef(expiresInMs);

  const diffInSeconds = Math.floor((expiresInRef.current - currentTime) / 1000);

  const countdown = useMemo(() => {
    if (diffInSeconds <= 1) {
      return {
        minutes: String(0).padStart(2, '0'),
        seconds: String(0).padStart(2, '0'),
      };
    }
    const days = Math.floor(diffInSeconds / ONE_DAY);
    const hours = Math.floor((diffInSeconds - days * ONE_DAY) / ONE_HOUR);

    const minutes = Math.floor((diffInSeconds - days * ONE_DAY - hours * ONE_HOUR) / ONE_MINUTE);
    const seconds = diffInSeconds - days * ONE_DAY - hours * ONE_HOUR - minutes * ONE_MINUTE;

    return {
      minutes: String(minutes).padStart(2, '0'),
      seconds: String(seconds).padStart(2, '0'),
    };
  }, [diffInSeconds]);

  useInterval(() => {
    const now = new Date().getTime();
    setCurrentTime(now);

    if (diffInSeconds === 0) {
      onExpire();
    }
  }, 1000);

  return (
    <span>
      {countdown.minutes}:{countdown.seconds}
    </span>
  );
}
